import { onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { auth } from "../../configurations/firebaseConfig";
import { profileImageUrl } from "../common/contants";
import { getLastUpdatedProfileImage } from "../settings/util/userSettings";

// 로그인한 사용자의 프로필 이미지 주소. 로그아웃 상태면 undefined.
export function useProfileImageSrc(): string | undefined {
  const [src, setSrc] = useState<string>();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setSrc(
          `${profileImageUrl}${
            user.providerData[0].uid
          }.jpg?t=${getLastUpdatedProfileImage()}`
        );
      } else {
        setSrc(undefined);
      }
    });
    return () => unsubscribe();
  }, []);

  return src;
}
